<div class="flex">
  <input pInputText [(ngModel)]="planet.name">
  <p-button (onClick)="save()" label="Save"></p-button>
</div>
